import RenderTable from './RenderTable'
import { AlgorithmTest } from '../../plugins/gatsby-source-stratascratch/algorithmTestsData'
import { resultsTable } from './DatasetPreview.module.css'

interface AlgorithmTestsValue {
  tests?: AlgorithmTest[]
  error?: string
  questionId?: string | number
}

interface Props {
  value: AlgorithmTestsValue
}

function formatData(data: string): string {
  try {
    const parsed = JSON.parse(data)
    if (Array.isArray(parsed)) {
      return JSON.stringify(parsed)
    }
    if (typeof parsed === 'object' && parsed !== null) {
      // Check if the object has a 'list' property
      if ('list' in parsed && Array.isArray(parsed.list)) {
        return JSON.stringify(parsed.list)
      }
    }
    return data
  } catch {
    return data
  }
}

function AlgorithmTestsWidget({ value }: Props) {
  const { tests, error, questionId } = value

  const columns = ['Input', 'Expected Output']
  const data = tests
    ? tests.map((test) => [formatData(test.input), formatData(test.output)])
    : []

  return (
    <div className={resultsTable}>
      {error && <p style={{ color: 'red' }}>Error: {error}</p>}

      {tests && tests.length > 0 ? (
        <div className={resultsTable}>
          <RenderTable columns={columns} data={data} />
        </div>
      ) : (
        <p>No tests data available for question ID: {questionId}</p>
      )}
    </div>
  )
}

export default AlgorithmTestsWidget
